export default {
  inject: ['load'],
  data() {
    return {
      medicalItemId: null,
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      customReportManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'عنوان', value: 'title', align: 'center' },
        { text: 'توضیحات', value: 'note', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      searchText: '',
    };
  },
  methods: {
    //search
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfCustomReportsWithPagination();
    },
    removeFilters: function () {
      this.searchText = '';
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfCustomReportsWithPagination();
    },
    cancelSearch: function () {
      this.searchText = '';
      this.searchModal = false;
    },
    goToReportItems: function (id) {
      this.$router.push({ name: 'customReportAmarItems', params: { id: id } });
    },
    goToQcReportItems: function (id) {
      this.$router.push({ name: 'QcCustomReportItem', params: { id: id } });
    },
  },
};
